export const informationBubbleStyles = `
.qae-root {
  position: absolute;
}
.qae-bubble {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background-color: var(--catchup-white);
  cursor: pointer;
  border-radius: var(--rad-catchup-2xlarge);
}
.qae-card {
  background-color: var(--catchup-white);
  border-radius: var(--rad-catchup-2xlarge);
  color: var(--catchup-blue-800);
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  z-index: 20;
  box-shadow: var(--shadow-input);
}
.qae-close {
  position: absolute;
  right: 1rem;
  top: 1.5rem;
}
.qae-close-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.qae-equation {
  font-size: var(--fs-2xl);
}
.qae-text {
  font-weight: 600;
  font-size: var(--fs-lg);
}
.qae-subtext {
  font-size: var(--fs-lg);
}
.qae-subtext-bold {
  font-weight: 600;
}
.qae-button-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 1.25rem;
}
.qae-tail {
  position: absolute;
  background-color: var(--catchup-white);
  right: 2.5rem;
  bottom: -0.75rem;
  z-index: 10;
}
.qae-tail-box {
  width: 3rem;
  height: 3rem;
  box-shadow: var(--shadow-input);
}
.qae-cover {
  position: absolute;
  background-color: var(--catchup-white);
  z-index: 30;
}
`;
